import AdminOperationsScreen from "../../../src/features/arrangements/screens/AdminOperationsScreen";

export default function CaseMemorialRoute() {
  return <AdminOperationsScreen screenIdOverride="website-memorial-management" />;
}
